import { ExecutiveDashboard, PerformancePage, BalancePage, IndicatorsPage } from "./finance-pages";
import { ActionPlansPage, ReportsPage, PresentationsPage, StrategicMapsPage } from "./management-pages";
import { PreferencesPage, RealizadosPage } from "./settings-pages";
import { AdminPage } from "./admin-page";
import { PlanResultsPage } from "./plan-results-page";
import { AccessGroupsPage } from "./access-groups-page";
import { ApplicationsPage, DevelopmentMapPage } from "./utility-pages";
import { BudgetPage } from "./orcamento-page";
import { ChatIAPage } from "./chat-ia-page";

/** Route declarations consumed by the single Vite shell. Keep aliases so existing bookmarks stay valid. */
export const pageRoutes = [
  { paths: ["/", "/dashboard"], component: ExecutiveDashboard },
  { paths: ["/performance"], component: PerformancePage },
  { paths: ["/balanco"], component: BalancePage },
  { paths: ["/indicadores"], component: IndicatorsPage },
  { paths: ["/planejamento/orcamento"], component: BudgetPage },
  { paths: ["/plano-de-acao", "/parametros/gestao-de-acoes"], component: ActionPlansPage },
  { paths: ["/relatorios"], component: ReportsPage },
  { paths: ["/apresentacoes", "/apresentacao"], component: PresentationsPage },
  { paths: ["/mapas-estrategicos", "/mapaestrategico"], component: StrategicMapsPage },
  { paths: ["/parametros/minhas-preferencias", "/minhas-preferencias"], component: PreferencesPage },
  { paths: ["/parametros/realizados", "/realizados"], component: RealizadosPage },
  { paths: ["/parametros/geral", "/geral", "/parametros"], component: AdminPage },
  { paths: ["/parametros/planos-de-resultado"], component: PlanResultsPage },
  { paths: ["/parametros/grupos"], component: AccessGroupsPage },
  { paths: ["/apps"], component: ApplicationsPage },
  { paths: ["/mapa"], component: DevelopmentMapPage },
  { paths: ["/chat-ia"], component: ChatIAPage },
];

export {
  ExecutiveDashboard,
  PerformancePage,
  BalancePage,
  IndicatorsPage,
  ActionPlansPage,
  ReportsPage,
  PresentationsPage,
  StrategicMapsPage,
  PreferencesPage,
  RealizadosPage,
  AdminPage,
  PlanResultsPage,
  AccessGroupsPage,
  ApplicationsPage,
  DevelopmentMapPage,
  BudgetPage,
  ChatIAPage,
};
